export default function() {

  const splashPage = () => {

    const currentURL = window.location.href;
    const currentPath = window.location.pathname;

    const splashPageHTML = `
      <div id="splashPage">
        <div class="splashPage-left">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div class="splashPage-right">
        </div>
        <div class="splashPage-content">
          <div class="splashPage-content__left">
            <img src="${FULLCLIENTTHEMEPATH}images/onc-splash-logo.png" alt="The Oncenter">
            <div class="splashPage-button splashPage-button__oncenter" tabindex="0">Visit Site</div>
          </div>
          <div class="splashPage-content__center">
            <img src="${FULLCLIENTTHEMEPATH}images/asm-splash-logo.png" alt="ASM Syracuse">
          </div>
          <div class="splashPage-content__right">
            <img src="${FULLCLIENTTHEMEPATH}images/St-Josephs-Health-Amphitheater-Logo-SingleColorr.svg" alt="St. Josephs Health Amphitheater">
            <div class="splashPage-button splashPage-button__amphitheater" tabindex="0">Visit Site</div>
          </div>                
        </div>
      </div>
    `;

    
    
    // Append Splash Page to document
    $('body').addClass('splashpage-active');
    $('body').prepend(splashPageHTML);
  
    
    // Button functionality
    const visitOncenter = () => {
      sessionStorage.setItem('siteTheme', 'Oncenter');
      window.location = currentURL;
    }
  
    const visitAmphitheater = () => {
      sessionStorage.setItem('siteTheme', 'Amphitheater');
      if (currentPath === '/') {
        window.location = `${SITEBASEURL}p/amphitheater`;
      } else {
        window.location = currentURL;
      }
    }
    
    $('.splashPage-button__oncenter').on('click keypress', function(e) {
      if (e.type === 'click' || e.key === 'Enter') {
        visitOncenter();
      }
    });
  
    $('.splashPage-button__amphitheater').on('click keypress', function(e) {
      if (e.type === 'click' || e.key === 'Enter') {
        visitAmphitheater();
      }
    });
  
  
  
    // Trap focus
    const modal = document.querySelector('#splashPage'); 
    const firstFocusableElement = modal.querySelectorAll('.splashPage-button')[0]; 
    const focusableContent = modal.querySelectorAll('.splashPage-button');
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; 
  
  
    document.addEventListener('keydown', function(e) {
      let isTabPressed = e.key === 'Tab';
  
      if (!isTabPressed) {
        return;
      }
  
      if (isTabPressed && $('body').hasClass('splashpage-active')) {
        if (e.shiftKey) { 
          if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus(); 
            e.preventDefault();
          }
        } else { 
          if (document.activeElement === lastFocusableElement) { 
            firstFocusableElement.focus(); 
            e.preventDefault();
          }
        }
      } else {
        return;
      }
  
    });
  }



  // if (sessionStorage.getItem('siteTheme') !== null) {
  //   return false;
  // } else {
  //   return splashPage();
  // }
  if (localStorage.getItem('siteTheme') !== null) {
    localStorage.removeItem('siteTheme');
    return false;
  } else if (sessionStorage.getItem('siteTheme') !== null) {
    return false; ;
  } else {
    return splashPage();
  }
}


